import {fetchBody} from "../../config"
import { toLogout, cleanFetch } from "../apiTools";
import { getToken } from "../../component/Login/Auth";
import { URL_CLIENT_GET_LIST, URL_CLIENT_ADD, URL_CLIENT_UPDATE, URL_CLIENT_SET_ACTIVATIONCODE, URL_CLIENT_SET_ACTIVATION, URL_CLIENT_SET_ACTCODECAP } from "../../setup/config_mystat";

export function api_getClientList ({mReqClient, success, failure}) {
  var token = getToken();
  if(token === ""){
    toLogout(false);
  }else{
    cleanFetch({
      body: fetchBody({body: mReqClient, token}), 
      url: URL_CLIENT_GET_LIST, 
      success:(jsonDate)=>{
        success(jsonDate)
      },
      failure:(error)=>{
        failure(error)
      }
    })
  }
}

export function api_addClient ({mRespClient, success, failure}) {
  var token = getToken();
  if(token === ""){
    toLogout(false);
  }else{
    console.log(mRespClient)
    cleanFetch({
      body: fetchBody({body: mRespClient, token}), 
      url: URL_CLIENT_ADD, 
      success:(jsonDate)=>{
        success(jsonDate)
      },
      failure:(error)=>{
        failure(error)
      }
    })
  }
}


export function api_updateClient ({mRespClient, success, failure}){
  var token = getToken();
  if(token === ""){
    toLogout(false);
  }else{
    cleanFetch({
      body: fetchBody({body: mRespClient, token}), 
      url: URL_CLIENT_UPDATE, 
      success:(jsonDate)=>{
        success(jsonDate)
      },
      failure:(error)=>{
        failure(error)
      }
    })
  }
}

export function api_setClientActivation({mRespClient, success, failure}){
  var token = getToken();
  if(token === ""){
    toLogout(false);
  }else{
    cleanFetch({
      body: fetchBody({body: mRespClient, token}), 
      url: URL_CLIENT_SET_ACTIVATION, 
      success:(jsonDate)=>{
        success(jsonDate)
      },
      failure:(error)=>{
        failure(error)
      }
    })
  }
}

export function api_setClientActivationCode({mRespClient, success, failure}){
  var token = getToken();
  if(token === ""){
    toLogout(false);
  }else{
    cleanFetch({
      body: fetchBody({body: mRespClient, token}), 
      url: URL_CLIENT_SET_ACTIVATIONCODE, 
      success:(jsonDate)=>{
        success(jsonDate)
      },
      failure:(error)=>{
        failure(error)
      }
    })
  }
}

export function api_setClientActCodeCap({mRespClient, success, failure}){
  var token = getToken();
  if(token === ""){
    toLogout(false);
  }else{
    cleanFetch({
      body: fetchBody({body: mRespClient, token}), 
      url: URL_CLIENT_SET_ACTCODECAP, 
      success:(jsonDate)=>{
        success(jsonDate)
      },
      failure:(error)=>{
        failure(error)
      }
    })
  }
}